import styled from 'styled-components';


function Footer() {
  return (
    <FooterContainer>
      <p>© {new Date().getFullYear()} Hi Blinds</p>

      <ContactSection>
        <Title>Contactos:</Title>
        <ContactGrid>
          <Contacto>
            <span>Richard Alvarez Rodríguez - </span>
            <a href="tel:4773059542">477 305 9542</a>
            <BtnWhats
              href="https://wa.me/524773059542"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </BtnWhats>
          </Contacto>
        </ContactGrid>
      </ContactSection>

      <p>
        Sitio creado por{' '}
        <LinkCreador
          href="https://reddigitalcreations.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Red Digital Creations
        </LinkCreador>
      </p>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer`
  background-color: #002A48;
  color: #EDEDED;
  text-align: center;
  padding: 20px 10px;
  font-size: 14px;
  margin-top: auto;
`;

const ContactSection = styled.div`
  margin: 10px 0 15px;
`;

const Title = styled.p`
  font-weight: bold;
  margin-bottom: 8px;
`;

const ContactGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media (min-width: 600px) {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 15px;
  }
`;

const Contacto = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;

  a {
    color: #ededed;

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    white-space: nowrap;
  }
`;

const BtnWhats = styled.a`
  background-color: #25d366;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #1ebc59;
  }
`;




const LinkCreador = styled.a`
  color: #FFBB00;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #FFD700; 
    text-decoration: underline;
  }
`;

export default Footer;